function createNormalizer(fn){return new Proxy({},{get(){return fn}})}var createProps=()=>props=>Array.from(new Set(props));export{createNormalizer,createProps};
//# sourceMappingURL=index.mjs.map